export * from './productSearchResults';
